import React, { useState } from 'react'
import {
    Flex,
    PageWrapper,
    PageFooter,
    H1WithBack,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { ModalTypes } from 'types/global.interface'
import { clearFoodInventoryItems, deleteFoodInventoryItem, getFoodInventoryItems } from 'features/food/foodSlice'
import { AddFoodItemModal, IAddFoodItemModalState } from './AddFoodItemModal'
import { IFoodInventoyItemSingleResponse } from 'types/api/foodApi.interface'

export const FoodItems: React.FC = () => {
    const { data, totalPages } = useSelector((store: RootState) => store.food.items)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState({ open: false, values: null })

    useQueryPagination({ fetchFunctions: [getFoodInventoryItems], cleanUpFunctions: [clearFoodInventoryItems], params })

    const removeItem = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFoodInventoryItem(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: data.length < 2,
                },
                word: 'delete food item',
            }),
        )
    }

    const getModalValues = (item: IFoodInventoyItemSingleResponse): IAddFoodItemModalState => {
        const values: IAddFoodItemModalState = {
            ...item,
            category: item.category ? { value: item.category.id, label: item.category.name } : null,
            ingredient: item.ingredient ? { value: item.ingredient.id, label: item.ingredient.name } : null,
            amount: item.remainingAmount,
        }
        return values
    }

    const columns: IHonestTableColumn<any>[] = [
        { id: 'name', header: 'NAME', cell: (item) => item.name },
        { id: 'category', header: 'CATEGORY', cell: (item) => item?.category?.name || '/' },
        { id: 'ingredient', header: 'INGREDIENT', cell: (item) => item?.ingredient?.name || '/' },
        { id: 'remainingAmount', header: 'REMAINING AMOUNT', cell: (item) => item?.remainingAmount },
        { id: 'price', header: 'PRICE', cell: (item) => item?.price },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <Options item={item} title='Food Item'
                        openModal={() => setModal({ open: true, values: getModalValues(item) })}
                        handleRemove={() => removeItem(item.id)}
                    />
                </span>
            ),
        },
    ]

    return (
        <>
            <NavBar setParams={setParams} />
            <PageWrapper>
                <Flex between center  >
                    <H1WithBack title='Food Items' arrow />
                    <Button variant='primary' onClick={() => setModal({ open: true, values: null })}>
                        Add Item
                    </Button>
                </Flex>
                {!data?.length ? (
                    <NoItems marginTop='1rem' title='Food Inventory Items' />
                ) : (
                    <HonestTable columns={columns} data={data} keyField='id' />
                )}
                {modal.open && <AddFoodItemModal closeModal={() => setModal({ open: false, values: null })} values={modal.values} />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
